import { SendRecording } from 'components/AudioRecorder/Recorder.api';
import { useEffect, useRef, useState } from 'react';
// import { SendRecording } from "../api/recorder.api";

const DURATION_TICK_MS = 200;
const DEFAULT_MAX_DURATION = 1000 * 60 * 60;

export function useAudioRecorder(fileType = 'mp3', autoUpload = false) {
  const recorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const audioBlobRef = useRef(null);

  const intervalRef = useRef(null);
  const startTimeRef = useRef(null);

  const timeoutRef = useRef(null);

  const [active, setActive] = useState(false);
  const [replaying, setReplaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [blob, setBlob] = useState(null);
  const [maxDuration, setMaxDuration] = useState(DEFAULT_MAX_DURATION);

  useEffect(() => {
    initializeRecorder();
  }, []);

  const initializeRecorder = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const recorder = new MediaRecorder(stream);
    recorderRef.current = recorder;

    recorder.ondataavailable = (e) => {
      if (e.data) audioChunksRef.current.push(e.data);
    };

    recorder.onstart = () => {
      clearAudio();
      startTimeRef.current = performance.now();
      intervalRef.current = setInterval(updateDuration, DURATION_TICK_MS);
      timeoutRef.current = setTimeout(stop, maxDuration);
    };

    recorder.onstop = () => {
      console.log('On Stop:', audioChunksRef.current);
      if (audioChunksRef.current.length > 0) {
        console.log('Creating and uploading audio blob');

        audioBlobRef.current = new Blob(audioChunksRef.current, {
          type: `audio/${fileType}`,
        });
        setBlob(audioBlobRef.current);

        if (autoUpload) trySend();
      } else console.error('No audio chunks in recording');

      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    };
  };

  const toggleRecording = (maxDuration) => {
    if (active) stop();
    else {
      setMaxDuration(maxDuration || DEFAULT_MAX_DURATION);
      startRecording();
    }
  };

  const clearAudio = () => {
    audioChunksRef.current = [];
    audioBlobRef.current = null;
    setBlob(null);
    setDuration(0);
  };

  const updateDuration = () => {
    const timeSinceStart = performance.now() - startTimeRef.current;
    setDuration(timeSinceStart);
  };

  //record 8-bit mono
  const startRecording = async () => {
    if (!recorderRef.current) return;

    setActive(true);
    setDuration(0);
    console.log('Starting recording');

    recorderRef.current.start();
  };

  const stop = () => {
    setActive(false);
    console.log('Stopping recording');

    recorderRef.current.stop();
  };

  const replayAudio = () => {
    if (!audioBlobRef.current) {
      setReplaying(false);
      return;
    }

    const audioURL = URL.createObjectURL(audioBlobRef.current);

    return <audio src={audioURL} autoPlay />;
  };

  const trySend = () => {
    if (!audioBlobRef.current) return;
    SendRecording(0, audioBlobRef.current, fileType);
  };

  return {
    blob,
    recording: active,
    duration,
    replaying,
    setReplaying,
    toggleRecording,
    replayAudio,
    trySend,
    clearAudio,
  };
}
